module.exports = __webpack_public_path__ + "static/img/avatar_r_2.ad9b47ea.png";